// extracted by mini-css-extract-plugin
export var active = "_cp-7";
export var container = "_cp-0";
export var evenWidth = "_cp-4";
export var large = "_cp-5";
export var outlet = "_cp-8";
export var slide = "_cp-2";
export var small = "_cp-6";
export var tab = "_cp-3";
export var tabs = "_cp-1";